<script lang="ts">
    import { page, router } from '@inertiajs/svelte';
    import { addToast, dismiss, getToasts } from '@/stores/toasts.svelte';

    // Listen for Inertia navigation success to pick up flash messages.
    // This avoids $effect dependency loops and fires on every response,
    // even when the flash message string is identical to the previous one.
    $effect(() => {
        const cleanup = router.on('success', () => {
            const flash = $page?.props?.flash as { message?: string; error?: string } | undefined;
            if (flash?.message) addToast(flash.message, 'success');
            if (flash?.error) addToast(flash.error, 'error');
        });
        return cleanup;
    });

    const toasts = $derived(getToasts());
</script>

<style>
    .toast-progress {
        animation: shrink 4s linear forwards;
    }
    @keyframes shrink {
        from { width: 100%; }
        to { width: 0%; }
    }
</style>

{#if toasts.length}
    <div class="fixed top-20 inset-x-0 z-50 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-end gap-2 pointer-events-none">
        {#each toasts as toast (toast.id)}
            <div
                class="pointer-events-auto rounded-lg shadow-lg text-sm font-medium transition-all duration-300 overflow-hidden {toast.leaving ? 'opacity-0 translate-x-4' : 'opacity-100 translate-x-0'} {toast.type === 'success' ? 'bg-green-600 text-white' : 'bg-red-600 text-white'}"
            >
                <div class="flex items-center gap-2 px-4 py-3">
                    <span class="flex-1">{toast.message}</span>
                    <button type="button" class="shrink-0 opacity-70 hover:opacity-100" onclick={() => dismiss(toast.id)} aria-label="Dismiss">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>
                    </button>
                </div>
                <div class="h-1 bg-white/30">
                    <div class="h-full bg-white/60 toast-progress"></div>
                </div>
            </div>
        {/each}
    </div>
{/if}
